// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'

// components
import { TableOfContents } from '@jelly/components'

// custom hooks
import { useToc } from '@jelly/utils'

// styled components
const LeftRailComponents = styled.div`
	display: none;
	margin-right: 25px;
	position: relative;
	width: 20%;
	min-width: 200px;

	${({ theme }) => theme.MQ.L} {
		display: inline-block;
	}
`
const TocContainer = styled.div`
	position: absolute;
	height: 100%;
`

LeftRail.propTypes = {
	tocElements: array.isRequired,
}

/*
    LeftRail made separate component to eliminate unnecessary re-rendering of child components triggered by scroll
*/
export function LeftRail({ docType, tocElements }) {
	const {
		tocState: { activeTocElement, isFooterVisible, isTocSticky, shouldShowToc, topOffset },
	} = useToc(tocElements)

	if (!shouldShowToc) {
		return null
	}

	return (
		<LeftRailComponents>
			<TocContainer>
				<TableOfContents
					activeTocElement={activeTocElement}
					docType={docType}
					isFooterVisible={isFooterVisible}
					isSticky={isTocSticky}
					tocElements={tocElements}
					topOffset={topOffset}
				/>
			</TocContainer>
		</LeftRailComponents>
	)
}
